/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Parcel_CodeInputs */

const vi_care_log_parcel_code = /** @type {(inputs: Care_Log_Parcel_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã lô`)
};

/**

* @param {Care_Log_Parcel_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_parcel_code = /** @type {((inputs?: Care_Log_Parcel_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Parcel_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_parcel_code(inputs)
});